export const toOptions = (items) => items.map(({ value, label }) => ({ value, label }))

export const buildUtmSelectOptions = (config) => ({
  channels: toOptions(config.channels),
  formats: toOptions(config.formats),
  directions: toOptions(config.directions),
  owners: toOptions(config.owners),
})
